import React from 'react';
import { Input, Button, Select, CheckboxTable } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ModeratorService } from 'services';

interface Props {
	onClose?: any;
	item: any;
	modules: any[];
}

class ModalCreate extends React.Component<Props> {

	state = {
		modules: [],
		form: {
			name: '',
			lastname: '',
			password: '',
			password_confirmation: '',
			email: '',
		},
		users: []
	}

	componentDidMount() {
		this.setState({
			modules: Globals.clone(this.props.modules),
		},() => {
			this.loadUsers();

			if (this.props.item) {
				this.setState({
					form: {
						...this.state.form,
						name: this.props.item?.name || '',
						lastname: this.props.item?.lastname || '',
						email: this.props.item?.email || '',
					},
					modules: Globals.clone(this.props.modules).map((i: any) => {
						if (this.props.item?.module_permissions) {
							const permission = this.props.item?.module_permissions.find((item: any) => item.module_id == i.id);
							if (permission) {
								i.read = permission.read == true;
								i.write = permission.write == true;
								i.delete = permission.delete == true;
							}
						}
						return i;
					})
				});
			}
		});
	}

	loadUsers = async () => {
		const res: any = await ModeratorService.admin.getUsers({
			withoutLoading: true,
			_user_id: this.props.item?.id
		});
		this.setState({
			users: res.users || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		await ModeratorService.admin.create({
			...this.state.form,
			_user_id: this.props.item?.id,
			module_permissions: this.state.modules.map((i: any) => {
				return {
					module_id: i.id,
					read: i.read,
					write: i.write,
					delete: i.delete
				}
			}),
			moderator_users: this.state.users.filter((i: any) => i.active).map((i: any) => i.id)
		});
		Globals.showSuccess(`Se ha ${ this.props.item != null ? 'modificado' : 'creado' } el moderador correctamente`);
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	checkModule = (index: number, target: string) => {
		let modules: any = [...this.state.modules];
		if (target == 'active') {
			if (modules[index]['write'] && modules[index]['read'] && modules[index]['delete']) {
				modules[index]['read'] = false;
				modules[index]['write'] = false;
				modules[index]['delete'] = false;
			}
			else {
				modules[index]['read'] = true;
				modules[index]['write'] = true;
				modules[index]['delete'] = true;
			}
		}
		else {
			modules[index][target] = !modules[index][target];
		}
		this.setState({
			modules
		});
	}

	checkUser = (index: number, target: string) => {
		let users: any = [...this.state.users];
		users[index].active = !users[index].active;
		this.setState({
			users
		});
	}
	
	render() {
		return (
			<div id="modal-update-user">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-6">
							<Input
								value={ this.state.form.name }
								label="Nombre"
								name="name"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.lastname }
								label="Apellido"
								name="lastname"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.email }
								label="Correo electrónico"
								name="email"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								label={ this.props.item != null ? 'Cambiar contraseña (Opcional)' : 'Contraseña' }
								type="password" 
								name="password"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								label="Repetir Contraseña"
								type="password" 
								name="password_confirmation"
								onChange={ this.change } />
						</div>
						<div className="col-md-12">
							<div className="container-cyan">
								<h3>Módulos Autorizados</h3>
								<table>
									<thead>
										<tr>
											<td style={{ paddingLeft: '10px' }}></td>
											<td className="text-center">Ver</td>
											<td className="text-center">Escribir</td>
											<td className="text-center" style={{ paddingRight: '10px' }}>Eliminar</td>
										</tr>
									</thead>
									<tbody>
										{
											this.state.modules?.map((item: any, index: number) => {
												return (
													<tr>
														<td style={{ paddingLeft: '10px' }}>
															<div className="td-check">
																<CheckboxTable
																	size="small" 
																	active={ item.read && item.write && item.delete } 
																	onClick={ () => this.checkModule(index,'active') } />
																{ item.name }
															</div>
														</td>
														<td className="td-center">
															<CheckboxTable 
																size="small" 
																active={ item.read } 
																onClick={ () => this.checkModule(index,'read') } />
														</td>
														<td className="td-center">
															<CheckboxTable 
																size="small" 
																active={ item.write } 
																onClick={ () => this.checkModule(index,'write') } />
														</td>
														<td className="td-center" style={{ paddingRight: '10px' }}>
															<CheckboxTable 
																size="small" 
																active={ item.delete } 
																onClick={ () => this.checkModule(index,'delete') } />
														</td>
													</tr>
												)
											})
										}
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-md-12">
							<div className="container-cyan">
								<h3 style={{ marginTop: '30px', marginBottom: '10px' }}>Usuarios Autorizados</h3>
								<div className="row">
									{
										this.state.users?.map((item: any, index: number) => {
											return (
												<div className="col-md-4">
													<div className="td-check" style={{ marginBottom: '10px' }}>
														<CheckboxTable
															size="small" 
															active={ item.active } 
															onClick={ () => this.checkUser(index,'active') } />
														{ item.name }
													</div>
												</div>
											)
										})
									}
								</div>
							</div>
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;